document.addEventListener('click', function (e) {
    const bannerATCBtn = e.target.closest('.PDP-banner__btn');
    if (bannerATCBtn) {
        const addToCartButton = document.querySelector('.avis-new-addcart-button');
        if (addToCartButton) {
            addToCartButton.click(); // Triggers a click (if it's a button)

        } else {
            const fallbackButton = document.querySelector('.product-form__cart-submit');
            if (fallbackButton) {
                fallbackButton.click();
            } else {
                console.error('No add-to-cart button found.');
            }
        }
        const redirectUrl = bannerATCBtn.dataset.href;
        if (redirectUrl) {
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 2000); 
        } else {
            console.error('No data-href attribute found on the clicked element.');
        }
    }
});